export const DEFAULT_TIMEOUT = 10000;
export const BEARER = 'Bearer';
export const SITE_WIDE_TODAYS_TRIP = 'SITE_WIDE_TODAYS_TRIP';
export const FLIGHT_NUMBER = '{{flightNumber}}';
